import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import PlanningHeadcountsEditModal from '../../Plannings/Elements/PlanningHeadcountsEditModal';

class PlanningHeadcountsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      planning_id: this.props.planning_id,
      planning_headcounts: [],
      staff_list: [],
    };

    //bind específico
    this.modalPropsOff = this.modalPropsOff.bind(this);
    this.showModal = this.showModal.bind(this);
  }
  
  // LM
  componentWillReceiveProps(newProps) {
    if(this.state.loaded === 0 && Array.isArray(newProps.planning_headcounts)) {
      this.setState({
        planning_headcounts: newProps.planning_headcounts,
        staff_list: newProps.staff_list,
        loaded: 1
      });
    }
  }
      
  loadData (value, event) {
    var self = this;
    var id = (value.id);
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/planejamento/revisao/info/edicao/'+ id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            data_planning_headcount: responseJson.data.main,
            planning_headcount_id: responseJson.data.main.id,
            planning_headcount_grade_vacations: responseJson.data.planning_headcount_grade_vacations,
            planning_headcount_grades_list: responseJson.data.planning_headcount_grades_list,
          });
          self.showModal();
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.modalPropsOff();
      }); /* Overlay */
    });
  }

  showModal (value, event) {
    this.setState({ modal_props: true});
  }
  
  modalPropsOff (event) {
    this.setState({ modal_props: false});
  }
  
  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <PlanningHeadcountsEditModal handleAlert={self.props.handleAlert} modal={self.state.modal_props} data_planning_headcount={self.state.data_planning_headcount} planning_headcount_id={self.state.planning_headcount_id} planning_headcount_grade_vacations={self.state.planning_headcount_grade_vacations} planning_headcount_grades_list={self.state.planning_headcount_grades_list} staff_list={self.state.staff_list} />
  <h3 className="page-title">Revisões</h3>
  <hr/>
  {(this.state.planning_headcounts === null || typeof this.state.planning_headcounts === 'undefined') ?  <div><small><em>Nenhuma revisão cadastrada.</em></small><hr/></div> 
  : 
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="text-center">Revisão</th>
          <th className="text-center">Status</th>
          <th className="col-md-1 text-center">Ações</th>
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.planning_headcounts).map(function(k) {
          return (
            <tr>
              <td className="text-center">{self.state.planning_headcounts[k].revision}</td>
              <td className="text-center">{self.state.planning_headcounts[k].status}</td>
              <td className="text-center">
                <button onClick={self.loadData.bind(self, self.state.planning_headcounts[k])} className='btn btn-sm btn-primary' alt='Editar' title='Editar'><i className="fa fa-fw fa-pencil"></i></button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }
</div>
    );
  }
}

export default PlanningHeadcountsTab;



// WEBPACK FOOTER //
// ./src/Components/Plannings/Elements/PlanningHeadcountsTab.js